import axios from 'axios'
import store from '../../store'
import { baseUrl } from '../../assets/js/env'
import { Toast } from 'vant'
import { paramsToSring, md5crypt, getRandomSixDigit } from '@/assets/js/AES'
import sha1 from 'sha1'
// import { getUrlKey } from '../../assets/js/data.js'

axios.defaults.timeout = 20000 // 设置请求时间
axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  store.commit('showLoading')
  return config
}, err => {
  store.commit('hideLoading')
  Toast('请求超时!')
  return Promise.resolve(err)
})
axios.interceptors.response.use(data => {
  store.commit('hideLoading')
  return data
}, err => {
  store.commit('hideLoading')
  console.log('err', err)
  if (err.response.status === 504 || err.response.status === 404) {
    Toast('服务器链接失败！')
  } else {
    Toast(err.response.data.msg)
  }
  console.log('111')
  // return Promise.resolve(err)
})

export const postRequest = async (url, params, header) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...header
    }
  })
}

export const jsonPostRequest = async (url, params, header) => {
  let timestamp = (Date.now() - 3000).toString()
  let nonce = getRandomSixDigit()
  let signature = sha1(timestamp + nonce)
  return axios({
    method: 'post',
    url: baseUrl + url,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      'timestamp': timestamp,
      'nonce': nonce,
      'signature': signature,
      'requestVersion': '0.0.1'
    }
  })
}

export const putRequest = async (url, params) => {
  return axios({
    method: 'put',
    url: baseUrl + url,
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export const deleteRequest = (url) => {
  return axios({
    method: 'delete',
    url: baseUrl + url
  })
}
export const getRequest = async (url, params = {}) => {
  // let hash = window.location.href
  let timestamp = (Date.now() - 3000).toString()
  let nonce = getRandomSixDigit()
  let signature = sha1(timestamp + nonce)
  return axios({
    method: 'get',
    params: {
      // mercId: sessionStorage.getItem('mercId') ? sessionStorage.getItem('mercId') : getUrlKey('mercId', hash),
      ...params
    },
    url: baseUrl + url,
    headers: {
      'timestamp': timestamp,
      'nonce': nonce,
      'signature': signature,
      'requestVersion': '0.0.1'
    }
  })
}
